import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getDictionary = (params) => {
    return axios.get(`${backendHost}/api/admin/dictionary`, {params});
};